module.exports = __webpack_public_path__ + "img/logoElectricalMarine2.99b55f07.png";